import OrganisationsTable from "./OrganisationsTable"
import { Box, Button, CircularProgress, Typography } from "@mui/material"
import { useNavigate } from "react-router"
import { useGetOrganisationsQuery } from "@store/services"
import { ContractDto } from "@custom-types/contract"
import { UserDto } from "@custom-types/user"

export default function Organisations() {
  const navigate = useNavigate()

  const { data: organisationsData, isFetching } = useGetOrganisationsQuery({})

  const onAddClick = () => {
    navigate("/Administration/Organisations/new")
  }

  return (
    <Box className={"admin-organisations"} sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Organisations
      </Typography>
      {isFetching ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box sx={{ mb: 4 }}>
            <OrganisationsTable
              data={organisationsData?.items ?? []}
              exportTransformFn={handleExportTransform}
            />
          </Box>
          <Box>
            <Button sx={{ mt: 1 }} variant="contained" onClick={onAddClick}>
              Add Organisation
            </Button>
          </Box>
        </>
      )}
    </Box>
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
const handleExportTransform = (inputData: any[]) => {
  const data =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
    inputData.reduce((acc, item: any) => {
      const tmpItem = { ...item }

      delete tmpItem.divisions

      acc = acc.concat(
        tmpItem.users.map((user: UserDto) => {
          const tmpUserObj = { ...tmpItem }

          delete tmpUserObj.users

          return {
            ...tmpUserObj,
            email_domains: item.email_domains.join(", "),
            user: `${user.first_name} ${user.last_name}`,
            contracts: tmpItem.contracts.map((contract: ContractDto) => contract.key).join(", "),
          }
        }),
      )

      return acc
    }, []) ?? []
  return { data, csvConfig: { filename: "pgm-organisations" } }
}
